import { render, staticRenderFns } from "@/style-guide/partials/twoLevelsSelector/twoLevelsSelector.pug?vue&type=template&id=4edffb8e&scoped=true&lang=pug&external"
import script from "./twoLevelsSelector.vue?vue&type=script&lang=ts"
export * from "./twoLevelsSelector.vue?vue&type=script&lang=ts"
import style0 from "./twoLevelsSelector.vue?vue&type=style&index=0&id=4edffb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edffb8e",
  null
  
)

export default component.exports